import './App.css';
import Logo from "../media/images/logo.svg";
import React from "react";
import FormChooser from "./FormChooser.mjs";
import FormTitle from "../components/FormTitle.mjs";
import { Glob as G } from "../libs/Glob.mjs";
import AdminIndex from "../admin/AdminIndex.mjs";
import MainMenu from "./MainMenu.mjs";
import EditForm from "../admin/editForm/EditForm.mjs";
import appLib from "../libs/appLib.mjs";
import AutoForm from "../autoForm/AutoForm.mjs";
import Login from "../login/Login.mjs";

class App extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			user: G.getUserLoginName(),
			admin: G.userIsAdmin(),
			groups: G.getUserLoginGroups(),
			group: appLib.group(),
			curpage: G.getCurrentPage()?.name || ''
		};
		this.uid = G.generateUid('App');
		this.autoPageOnLoginChange = this.autoPageOnLoginChange.bind(this);
		this.paneChooser = this.paneChooser.bind(this);
	}
	componentDidMount() {
		G.register('userLogin', ()=>{
			const s = {
				user: G.getUserLoginName(),
				admin: G.userIsAdmin(),
				groups: G.getUserLoginGroups(),
				group: appLib.group(),
				curpage: G.getCurrentPage()?.name || '',
				item: G.getStatus('currentItem')
			};
			this.setState(s, this.autoPageOnLoginChange );
		}, this.uid);
		appLib.onGroupChange( n =>{
			this.setState({ group: n }, this.autoPageOnLoginChange);
		}, this.uid);
		G.register('currentItem', i => { this.setState({ item: i }); }, this.uid);
		G.register('currentPage', po => {
			const cp = po?.name || '';
			const scg = appLib.group();
			let cg =  scg;
			if ( po?.name === 'Admin' ) {
				cg = 'admin';
			} else if ( po?.params?.group && po.params.group !== cg ) {
				cg = po.params.group;
			}
			if ( cg ) {
				if ( cg !== scg) appLib.group(cg);
				if ( cg !== 'admin' && po?.params?.group !== cg) G.setCurrentPageParam('group', cg);
			}
			if ( cp !== this.state.curpage ) this.setState({ curpage: cp });
		}, this.uid);
		G.register(['pageButtons'], b => { this.setState({ hasPageButtons: !! b }); }, this.uid);
		G.setStatus('pageTitle','');
	}
	componentWillUnmount() {
		G.deregister(this.uid);
	}
	autoPageOnLoginChange() {
		const cp = this.state.curpage;
		if ( ! this.state.user ) {
			if ( cp !== 'Login') G.gotoPage('Login');
			return ;
		}
		if ( this.state.admin && cp === 'EditForm' ) return;
		if ( this.state.admin && this.state.group === 'admin' ) {
			if ( cp !== 'Admin') G.gotoPage('Admin');
			return;
		}
		if ( this.state.group ) {
			G.gotoPage('FormChooser');
			return;
		}
		if ( cp !== 'MainMenu') G.gotoPage('MainMenu');
	}
	paneChooser() {
		if ( ! this.state.user ) {
			if ( this.state.curpage !== 'Login') {
				G.gotoPage('Login');
			}
			return <Login />;
		}
		switch ( this.state.curpage ) {
			case 'Login': return <Login />;
			case 'Admin': return <AdminIndex />;
			case 'MainMenu': return <MainMenu />;
			case 'EditForm': return <EditForm />;
			case 'Form': return <AutoForm />;
			default: return <FormChooser />;
		}
	}
	render() {
		return (
			<div className="App" id={this.uid}>
				<header className={"App-header"}>
					<div className={"logo"}>
						<img src={Logo} alt={"HB"}/>
					</div>
					<FormTitle/>
				</header>
				<div className={"App-body"}>
					<div className={"App-body-content"}>
						{this.paneChooser()}
					</div>
				</div>
			</div>
		);
	}
}

export default App;
